// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var MM_wrk_settings = require("../worker/MM_wrk_settings.bs.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.bs.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.bs.js");
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.bs.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.bs.js");
var Select = require("@mui/material/Select").default;
var MM_cmp_pe_frame_list = require("./MM_cmp_pe_frame_list.bs.js");
var MM_cmp_asrts_per_page = require("./MM_cmp_asrts_per_page.bs.js");
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var InputLabel = require("@mui/material/InputLabel").default;
var FormControl = require("@mui/material/FormControl").default;
var FilterAlt = require("@mui/icons-material/FilterAlt").default;
var FormControlLabel = require("@mui/material/FormControlLabel").default;
var FilterAltOff = require("@mui/icons-material/FilterAltOff").default;

function propsAreSame(a, b) {
  if (a.preCtxData === b.preCtxData) {
    return a.ctxSelectorIsExpanded === b.ctxSelectorIsExpanded;
  } else {
    return false;
  }
}

var make = React.memo((function (param) {
        var ctxSelectorIsExpanded = param.ctxSelectorIsExpanded;
        var toggleCtxSelector = param.toggleCtxSelector;
        var preCtxData = param.preCtxData;
        var modalRef = param.modalRef;
        var settings = preCtxData.settingsV.val;
        var preCtx = preCtxData.ctxV.val;
        var match = React.useState(function () {
              return preCtxData.ctxV.ver;
            });
        var setPreCtxVer = match[1];
        var match$1 = React.useState(function () {
              return MM_wrk_settings.settingsGetTypeColors(settings);
            });
        var setTypeColors = match$1[1];
        var match$2 = React.useState(function () {
              return [];
            });
        var setAllLabels = match$2[1];
        var allLabels = match$2[0];
        var match$3 = React.useState(function () {
              return [];
            });
        var setFilteredLabels = match$3[1];
        var match$4 = React.useState(function () {
              return [];
            });
        var setAllStmtTypes = match$4[1];
        var allStmtTypes = match$4[0];
        var match$5 = React.useState(function () {
              return "all";
            });
        var setAllStmtTypesConcat = match$5[1];
        var allStmtTypesConcat = match$5[0];
        var match$6 = React.useState(function () {
              
            });
        var setIsAxiomFilter = match$6[1];
        var isAxiomFilter = match$6[0];
        var match$7 = React.useState(function () {
              
            });
        var setStmtTypeFilter = match$7[1];
        var stmtTypeFilter = match$7[0];
        var match$8 = React.useState(function () {
              return "";
            });
        var setLabelFilter = match$8[1];
        var labelFilter = match$8[0];
        var match$9 = React.useState(function () {
              return "";
            });
        var setPatternFilterStr = match$9[1];
        var patternFilterStr = match$9[0];
        var match$10 = React.useState(function () {
              
            });
        var setPatternFilterErr = match$10[1];
        var patternFilterErr = match$10[0];
        var match$11 = React.useState(function () {
              return false;
            });
        var setDiscFilter = match$11[1];
        var discFilter = match$11[0];
        var match$12 = React.useState(function () {
              return false;
            });
        var setDeprFilter = match$12[1];
        var deprFilter = match$12[0];
        var match$13 = React.useState(function () {
              return false;
            });
        var setTranDeprFilter = match$13[1];
        var tranDeprFilter = match$13[0];
        var match$14 = React.useState(function () {
              return false;
            });
        var setApplyFiltersRequested = match$14[1];
        var applyFiltersRequested = match$14[0];
        var match$15 = React.useState(function () {
              return false;
            });
        var setMainMenuIsOpened = match$15[1];
        var mainMenuIsOpened = match$15[0];
        var mainMenuButtonRef = React.useRef(null);
        var match$16 = Local_storage_utils.useStateFromLocalStorageInt("pe-index-asrts-per-page", 10);
        var setAsrtsPerPage = match$16[1];
        var asrtsPerPage = match$16[0];
        var actClearFilters = function (applyFilters) {
          Curry._1(setIsAxiomFilter, (function (param) {
                  
                }));
          Curry._1(setStmtTypeFilter, (function (param) {
                  
                }));
          Curry._1(setLabelFilter, (function (param) {
                  return "";
                }));
          Curry._1(setPatternFilterStr, (function (param) {
                  return "";
                }));
          Curry._1(setPatternFilterErr, (function (param) {
                  
                }));
          Curry._1(setDiscFilter, (function (param) {
                  return false;
                }));
          Curry._1(setDeprFilter, (function (param) {
                  return false;
                }));
          Curry._1(setTranDeprFilter, (function (param) {
                  return false;
                }));
          if (applyFilters) {
            return Curry._1(setApplyFiltersRequested, (function (param) {
                          return true;
                        }));
          }
          
        };
        var actApplyFilters = function (param) {
          var patternFilterSyms = Common.getSpaceSeparatedValuesAsArray(patternFilterStr);
          var incorrectSymbol = patternFilterSyms.find(function (sym) {
                return !MM_context.isConst(preCtxData.ctxV.val, sym);
              });
          if (incorrectSymbol !== undefined) {
            return Curry._1(setPatternFilterErr, (function (param) {
                          return "'" + incorrectSymbol + "' - is not a constant.";
                        }));
          }
          Curry._1(setPatternFilterErr, (function (param) {
                  
                }));
          var patternFilterInts = MM_context.ctxSymsToIntsExn(preCtxData.ctxV.val, patternFilterSyms);
          Curry._1(setFilteredLabels, (function (param) {
                  return allLabels.filter(function (param) {
                              var label = param[1];
                              var frame = MM_context.getFrameExn(preCtxData.ctxV.val, label);
                              if (Belt_Option.mapWithDefault(isAxiomFilter, true, (function (isAxiomFilter) {
                                        return isAxiomFilter === frame.isAxiom;
                                      })) && Belt_Option.mapWithDefault(stmtTypeFilter, true, (function (stmtType) {
                                        return stmtType === Caml_array.get(frame.asrt, 0);
                                      })) && (!discFilter || frame.isDisc) && (!deprFilter || frame.isDepr) && (!tranDeprFilter || frame.isTranDepr) && label.toLowerCase().includes(labelFilter.toLowerCase())) {
                                return MM_wrk_search_asrt.frameMatchesPattern(frame, patternFilterInts);
                              } else {
                                return false;
                              }
                            });
                }));
        };
        React.useEffect((function () {
                if (applyFiltersRequested) {
                  Curry._1(setApplyFiltersRequested, (function (param) {
                          return false;
                        }));
                  actApplyFilters(undefined);
                }
                
              }), [applyFiltersRequested]);
        var actPreCtxDataChanged = function (param) {
          var settings = preCtxData.settingsV.val;
          Curry._1(setTypeColors, (function (param) {
                  return MM_wrk_settings.settingsGetTypeColors(settings);
                }));
          var preCtx = preCtxData.ctxV.val;
          Curry._1(setPreCtxVer, (function (param) {
                  return preCtxData.ctxV.ver;
                }));
          var allLabels = MM_context.getAllFrameLabels(preCtx).map(function (label, i) {
                return [
                        i + 1 | 0,
                        label
                      ];
              });
          Curry._1(setAllLabels, (function (param) {
                  return allLabels;
                }));
          Curry._1(setFilteredLabels, (function (param) {
                  return allLabels;
                }));
          var allStmtIntTypes = [];
          MM_context.forEachFrame(preCtx, (function (frame) {
                  var stmtTyp = Caml_array.get(frame.asrt, 0);
                  if (!allStmtIntTypes.includes(stmtTyp)) {
                    allStmtIntTypes.push(stmtTyp);
                  }
                  
                }));
          var allStmtTypes = MM_context.ctxIntsToSymsExn(preCtx, allStmtIntTypes).sort();
          Curry._1(setAllStmtTypes, (function (param) {
                  return allStmtTypes;
                }));
          Curry._1(setAllStmtTypesConcat, (function (param) {
                  return "all" + allStmtTypes.join("");
                }));
          actClearFilters(false);
        };
        React.useEffect((function () {
                actPreCtxDataChanged(undefined);
              }), [preCtxData]);
        var isAxiomFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            if (typeFilter) {
              return "true";
            } else {
              return "false";
            }
          } else {
            return "none";
          }
        };
        var stmtTypeFilterToStr = function (typeFilter) {
          if (typeFilter !== undefined) {
            return MM_context.ctxIntToSymExn(preCtx, typeFilter);
          } else {
            return allStmtTypesConcat;
          }
        };
        var actIsAxiomFilterUpdated = function (isAxiomStr) {
          Curry._1(setIsAxiomFilter, (function (param) {
                  switch (isAxiomStr) {
                    case "false" :
                        return false;
                    case "true" :
                        return true;
                    default:
                      return ;
                  }
                }));
        };
        var actStmtTypeFilterUpdated = function (stmtTypeStr) {
          Curry._1(setStmtTypeFilter, (function (param) {
                  if (stmtTypeStr === allStmtTypesConcat) {
                    return ;
                  } else {
                    return MM_context.ctxSymToInt(preCtx, stmtTypeStr);
                  }
                }));
        };
        var actLabelFilterUpdated = function (newLabelFilter) {
          Curry._1(setLabelFilter, (function (param) {
                  return newLabelFilter;
                }));
        };
        var actPatternFilterStrUpdated = function (newPatternFilterStr) {
          Curry._1(setPatternFilterStr, (function (param) {
                  return newPatternFilterStr;
                }));
        };
        var actDiscFilterUpdated = function (newDiscFilter) {
          Curry._1(setDiscFilter, (function (param) {
                  return newDiscFilter;
                }));
        };
        var actDeprFilterUpdated = function (newDeprFilter) {
          Curry._1(setDeprFilter, (function (param) {
                  return newDeprFilter;
                }));
        };
        var actTranDeprFilterUpdated = function (newTranDeprFilter) {
          Curry._1(setTranDeprFilter, (function (param) {
                  return newTranDeprFilter;
                }));
        };
        React.useEffect((function () {
                actApplyFilters(undefined);
              }), [
              isAxiomFilter,
              stmtTypeFilter,
              discFilter,
              deprFilter,
              tranDeprFilter
            ]);
        var actCloseMainMenu = function (param) {
          Curry._1(setMainMenuIsOpened, (function (param) {
                  return false;
                }));
        };
        var rndIsAxiomFilter = function (param) {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "isAxiomFilter-label",
                          children: "Assertion type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "isAxiomFilter-label",
                          label: "Assertion type",
                          value: isAxiomFilterToStr(isAxiomFilter),
                          onChange: (function (param) {
                              return Expln_React_common.evt2str(actIsAxiomFilterUpdated, param);
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: "none",
                              children: "All"
                            }), React.createElement(MenuItem, {
                              value: "true",
                              children: "Axiom"
                            }), React.createElement(MenuItem, {
                              value: "false",
                              children: "Theorem"
                            })));
        };
        var rndStmtTypeFilter = function (param) {
          return React.createElement(FormControl, {
                      size: "small",
                      children: Caml_option.some(null)
                    }, React.createElement(InputLabel, {
                          id: "stmtTypeFilter-label",
                          children: "Statement type"
                        }), React.createElement(Select, {
                          sx: {
                            width: 130
                          },
                          labelId: "stmtTypeFilter-label",
                          label: "Statement type",
                          value: stmtTypeFilterToStr(stmtTypeFilter),
                          onChange: (function (param) {
                              return Expln_React_common.evt2str(actStmtTypeFilterUpdated, param);
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(MenuItem, {
                              value: allStmtTypesConcat,
                              children: "All"
                            }), allStmtTypes.map(function (stmtType) {
                              return JsxPPXReactSupport.createElementWithKey(stmtType, MenuItem, {
                                          value: stmtType,
                                          children: Caml_option.some(stmtType)
                                        });
                            })));
        };
        var rndLabelFilter = function (param) {
          return React.createElement(TextField, {
                      value: labelFilter,
                      label: "Label",
                      size: "small",
                      style: {
                        width: "200px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actLabelFilterUpdated, param);
                        }),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters, undefined),
                      autoFocus: true
                    });
        };
        var rndPatternFilter = function (param) {
          return React.createElement(TextField, {
                      value: patternFilterStr,
                      label: "Pattern",
                      size: "small",
                      style: {
                        width: "300px"
                      },
                      onChange: (function (param) {
                          return Expln_React_common.evt2str(actPatternFilterStrUpdated, param);
                        }),
                      onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEnter, undefined, undefined, undefined, actApplyFilters, undefined)
                    });
        };
        var rndPatternError = function (param) {
          if (patternFilterErr !== undefined) {
            return React.createElement("pre", {
                        style: {
                          color: "red"
                        }
                      }, "Malformed pattern text: " + patternFilterErr);
          } else {
            return React.createElement(React.Fragment, undefined);
          }
        };
        var rndDiscFilter = function (param) {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: discFilter,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool(actDiscFilterUpdated, param);
                              })
                          }),
                      label: "Discouraged",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndDeprFilter = function (param) {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: deprFilter,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool(actDeprFilterUpdated, param);
                              })
                          }),
                      label: "Deprecated",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndTranDeprFilter = function (param) {
          return React.createElement(FormControlLabel, {
                      control: React.createElement(Checkbox, {
                            checked: tranDeprFilter,
                            onChange: (function (param) {
                                return Expln_React_common.evt2bool(actTranDeprFilterUpdated, param);
                              })
                          }),
                      label: "Transitively deprecated",
                      style: {
                        marginTop: "-2px",
                        marginLeft: "2px",
                        paddingRight: "10px"
                      }
                    });
        };
        var rndApplyFiltersBtn = function (param) {
          return React.createElement("span", {
                      title: "Apply filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actApplyFilters(undefined);
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAlt, {}))
                        }));
        };
        var rndClearFiltersBtn = function (param) {
          return React.createElement("span", {
                      title: "Clear filters"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              actClearFilters(true);
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(FilterAltOff, {}))
                        }));
        };
        var rndMainMenuBtn = function (param) {
          return React.createElement("span", {
                      ref: Caml_option.some(mainMenuButtonRef),
                      title: "Additional actions"
                    }, React.createElement(IconButton, {
                          onClick: (function (param) {
                              Curry._1(setMainMenuIsOpened, (function (param) {
                                      return true;
                                    }));
                            }),
                          color: "primary",
                          children: Caml_option.some(React.createElement(Menu, {}))
                        }));
        };
        var rndFilters = function (param) {
          return React.createElement(Expln_React_Column.make, {
                      children: Caml_option.some(null)
                    }, React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndIsAxiomFilter(undefined), rndLabelFilter(undefined), rndPatternFilter(undefined), rndApplyFiltersBtn(undefined), rndClearFiltersBtn(undefined), rndMainMenuBtn(undefined)), React.createElement(Expln_React_Row.make, {
                          children: Caml_option.some(null)
                        }, rndStmtTypeFilter(undefined), rndDiscFilter(undefined), rndDeprFilter(undefined), rndTranDeprFilter(undefined)));
        };
        var rndMainMenu = function (param) {
          if (!mainMenuIsOpened) {
            return React.createElement(React.Fragment, undefined);
          }
          var mainMenuButtonRef$1 = mainMenuButtonRef.current;
          if (mainMenuButtonRef$1 == null) {
            return React.createElement(React.Fragment, undefined);
          } else {
            return React.createElement(Expln_React_Menu.make, {
                        opn: true,
                        anchorEl: Caml_option.some(mainMenuButtonRef$1),
                        onClose: actCloseMainMenu,
                        children: Caml_option.some(null)
                      }, React.createElement(MenuItem, {
                            onClick: (function (param) {
                                Curry._1(setMainMenuIsOpened, (function (param) {
                                        return false;
                                      }));
                                Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                        Curry._1(toggleCtxSelector, undefined);
                                      }));
                              }),
                            children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                          }), React.createElement(MenuItem, {
                            onClick: (function (param) {
                                Curry._1(setMainMenuIsOpened, (function (param) {
                                        return false;
                                      }));
                                Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                            return null;
                                          })), (function (modalId) {
                                        Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                return React.createElement(MM_cmp_asrts_per_page.make, {
                                                            initAsrtsPerPage: String(asrtsPerPage),
                                                            onOk: (function (strNum) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                var num = Belt_Int.fromString(strNum);
                                                                if (num !== undefined) {
                                                                  return Curry._1(setAsrtsPerPage, (function (param) {
                                                                                return Math.max(1, Math.min(num, 100));
                                                                              }));
                                                                }
                                                                
                                                              }),
                                                            onCancel: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                              })
                                                          });
                                              }));
                                      }));
                              }),
                            children: Caml_option.some("Assertions per page: " + String(asrtsPerPage) + "")
                          }));
          }
        };
        return React.createElement(Expln_React_Column.make, {
                    style: {
                      margin: "15px"
                    },
                    children: Caml_option.some(null)
                  }, rndFilters(undefined), rndPatternError(undefined), rndMainMenu(undefined), JsxPPXReactSupport.createElementWithKey("" + String(match[0]) + "", MM_cmp_pe_frame_list.make, {
                        modalRef: modalRef,
                        typeColors: match$1[0],
                        editStmtsByLeftClick: settings.editStmtsByLeftClick,
                        settings: preCtxData.settingsV.val,
                        preCtx: preCtx,
                        frms: preCtxData.frms,
                        parenCnt: preCtxData.parenCnt,
                        syntaxTypes: preCtxData.syntaxTypes,
                        labels: match$3[0],
                        openFrameExplorer: param.openFrameExplorer,
                        asrtsPerPage: asrtsPerPage
                      }));
      }), propsAreSame);

exports.propsAreSame = propsAreSame;
exports.make = make;
/* make Not a pure module */
